import apiUrls from 'apis/apiUrls';
import { axiosInstance } from 'helper/axiosHelper';

const appService = {
  getCityByZone: (params: { zone: string }) => {
    return axiosInstance.makeGetRequest({
      url: apiUrls.getCityByZone(),
      config: { params },
    });
  },

  getAllCity: (params) => {
    return axiosInstance.makeGetRequest({
      url: apiUrls.getAllCity(),
      config: { params },
    });
  },

  getAllZones: (params) => {
    return axiosInstance.makeGetRequest({
      url: apiUrls.getAllZones(),
      config: { params },
    });
  },

  addNewZone: (data: any) => {
    return axiosInstance.makePostRequest({
      url: apiUrls.addNewZone(),
      data,
    });
  },

  addNewCity: (data: any) => {
    return axiosInstance.makePostRequest({
      url: apiUrls.addNewCity(),
      data,
    });
  },
};

export default appService;
